const newsBackLink = Array.from(document.querySelectorAll('.j-news-back'));

newsBackLink.forEach((item) => {
    item.addEventListener('click', () => {
        if (window.history.length > 2) {
            window.history.back();
        } else {
            window.location.href = item.dataset.href;
        }
    });
});
